






























































































import { Vue, Component, Prop } from 'vue-property-decorator';
// Components
import BaseModal from '@/components/common/BaseModal.vue';
import FormAction from '@/components/common/FormAction.vue';
import LazyloadImage from '@components/image/LazyloadImage.vue';

import ApiHelper from 'api-helper';
import { Plan } from '@/models/plan';
import Toast from '@common/helpers/toast';
import { findSelectedPlan } from '@common/helpers/plan-highlight';

@Component({
  components: {
    BaseModal,
    FormAction,
    LazyloadImage,
  },
})
export default class ModalChangePlan extends Vue {
  @Prop(String) readonly name: string;
  @Prop(Boolean) readonly isSubmitting: boolean;
  /** ID of the patient's currently active plan — excluded from the selection list. */
  @Prop({ type: Number, default: null }) readonly activePlanId: number | null;

  isLoading: boolean = false;
  plans: Plan[] = [];
  selectedPlanId = null;
  isShowMsg: boolean = false;
  reMonshin: boolean | null = null;

  beforeOpen() {
    this.selectedPlanId = null;
    this.isShowMsg = false;
    this.reMonshin = null;
    this.getPlans();
  }

  getPlans() {
    this.isLoading = true;
    const self = this;
    ApiHelper
      .getApi('PlanApi').fetchPlanList({karte_status: true})
      .then(function(res) {
        self.plans = res.data
          .map((item) => new Plan().deserialize(item))
          .filter((plan) => Number(plan.id) !== Number(self.activePlanId));
      })
      .catch((error: any) => {
        Toast.error(error.response.data.message);
      })
      .finally(function() {
        self.isLoading = false;
      });
  }

  choosePlan(plan) {
    this.selectedPlanId = plan.id;
    this.isShowMsg = true;
    this.reMonshin = null;
  }

  get selectedPlan(): Plan | undefined {
    return findSelectedPlan(this.plans, this.selectedPlanId);
  }
}
